import * as React from 'react';
import { Box, Stack, Typography, Snackbar, Alert, Tabs, Tab } from "@mui/material";
import OrderNotes from './BottomTabs/OrderNotes';
import CustomTabPanel from '../../components/CustomTabPanel';
import OrderDocuments from './BottomTabs/OrderDocuments';
import OrderHistory from './BottomTabs/OrderHistory';

export default function BottomTabs(props) {
  const { params, existingDocuments, snackBarHandler, onRefreshDocuments,category } = props;
  const [activeTab, setActiveTab] = React.useState(0);

  return (
    <Box >
      <Tabs
        value={activeTab}
        onChange={(event, newValue) => setActiveTab(newValue)}
        aria-label="wrapped label tabs example"
      >
        <Tab
          value={0}
          label="Notes"
        />
        <Tab value={1} label="Documents" />
        <Tab value={2} label="History" />
      </Tabs>
      <CustomTabPanel value={activeTab} index={0}>
        {params.controlNumber != 'new'?(
          <OrderNotes
          controlNumber={params.controlNumber}
          locationNumber={params.locationNumber}
          category={category||"orders"}
        />
        ): null}
      </CustomTabPanel>
      <CustomTabPanel value={activeTab} index={1}>
        {params.controlNumber != 'new'?(
          <OrderDocuments
            controlNumber={params.controlNumber}
            locationNumber={params.locationNumber}
            existingDocuments={existingDocuments}
            snackBarHandler={snackBarHandler}
            onRefreshDocuments={onRefreshDocuments}
            category={category||"orders"}
          />
        ): null}
      </CustomTabPanel>
      <CustomTabPanel value={activeTab} index={2}>
        {params.controlNumber != 'new'?(
          <OrderHistory
          controlNumber={params.controlNumber}
          locationNumber={params.locationNumber}
          category={category||"orders"}
        />
        ): null}
      </CustomTabPanel>
    </Box>
  );
}
